const env = process.env.NODE_ENV || 'development'
const taxRegistration = '/api/v1/taxregistration'

function getEndpoints () {
  return {
    taxReturns: '/api/v1/taxreturn/?scope=tile',
    lastImport: '/api/v1/importlog/lastrun',
    configData: '/api/v1/configuration/count',
    taxSummary: '/api/v1/summary-data',
    taxReturnSubmit: '/api/v1/taxreturn/submission',
    taxReturnSummary: '/api/v1/taxreturn/',
    vatAdjustment: '/api/v1/vatadjustment/',
    libraryData: '/api/v1/importlog',
    importSummaryData: '/api/v1/importlog/lastrun',
    taxRegistrations: taxRegistration,
    taxRegistrationVerify: '/api/v1/taxregistration/verify',
    userList: '/api/v1/keycloak/user',
    importErrors: '/api/v1/text-registrations',
    userAuthLogin: '/api/v1/auth/user',
    userAuthRefresh: '/api/v1/auth/user/refresh',
    userForgotPassword: '/api/v1/keycloak/user/forgottenpassword',
    submittedTaxReturn: '/api/v1/taxreturn/?scope=submitted-summary',
    importBasic: '/api/v1/import/basic',
    importTransaction: '/api/v1/import/transaction',
    submissionGateway: '/api/v1/submissiongateway',
    currentUser: '/api/v1/user/current',
    hmrcAuthenticationCode: '/tess/hmrcauthenticationcode',
    hmrcAuthenticationStatus: '/tess/hmrcauthenticationstatus',
    tenantRegister: '/tenant/register',
    tenantRegisterStatus: '/tenant/register/status',
    tenantExists: '/tenant/exists',
    adminLogin: '/tenant/login',
    adminAuthRefresh: '/api/v1/auth/admin/refresh',
    userLogout: '/api/v1/auth/user/logout',
    config: '/config/428345632213?valid=true',
    layoutBoxes: '/api/v1/layout',
    fmsConnection: '/api/v1/keycloak/client',
    taxCodes: '/api/v1/taxcode',
    taxCodeMapping: '/api/v1/taxcodemapping',
    companies: '/api/v1/taxregistration/?scope=list-company',
    taxRegistrationCompanies: taxRegistration,
    layouts: '/api/v1/layout/?scope=box-summary',
    adminTenants: '/api/v1/admin/tenant/',
    provisionTenant: '/api/v1/admin/provisiontenant',
    adjustmentList: '/api/v1/taxreturn',
    workflow: '/api/v1/workflow',
    workflowUser: '/api/v1/keycloak/user/workflow/approvers',
    taxCodeIOIndicator: '/api/v1/taxcode/?scope=io-indicator',
    reconciliationDetails: '/api/v1/reconciliation/',
    attachment: '/api/v1/attachment',
    tolerance: '/api/v1/tolerance/',
    obligation: '/api/v1/obligation/',
    taxLiabilities: '/api/v1/taxregistration/',
    taxPayments: '/api/v1/taxregistration/',
    enhancedSearch: '/api/v1/enhancedsearch'
  }
}

const dsMap = {
  'development': getEndpoints(),
  'production': getEndpoints()
}

export const dataSources = () => dsMap[env]